export default __webpack_public_path__ + "static/media/36I-102612_-17030_0.bc6189a1.jpg";